import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import { Badge, Form } from "reactstrap";
import MyInput from "../../MyComp/UI/form/MyInput";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import { categoryDDAPI } from "../../api/dropdown";
import { toast } from "react-toastify";
import MySelect from "../../MyComp/UI/form/MySelect";
import { addVideoArticleAPI, listVideoArticleAPI, updateVideoArticleAPI } from "../../api/blog";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { BASE_URL_IMG } from "../../assets/constants";
import ReactPlayer from "react-player";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import { UserAvatarCell } from "../../MyComp/ImagePre/UserAvatarCell";

const VideoArticle = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      loading: false,
      data: [],
      categoryDD: [],
      image: null,
      img: null,
      url: null,
      publish: false,
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const loading = watch("loading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [column, setColumn] = useState([
    {
      name: "Name",
      selector: (row) => row?.title,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.image)}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
            alt={row?.title || "blog"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
           <UserAvatarCell
            row={row}
            image={row?.image ? `${BASE_URL_IMG}${row?.image}` : "/default-avatar.png"}
            name={row?.title}
            handleImageOpenPreview={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.image)}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
                
              }}
            >
              {row?.title || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {/* {row?.mobile || row?.contact_number} */}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      wrap:true
    },
    {
      name: "Category",
      selector: (row) => row?.category?.label,
      sortable: true,
      
      width: "120px",
    },
    {
      name: "Description",
      selector: (row) => row?.description,
      sortable: true,
      wrap:true
    },

   
    {
      name: "Video", 
      selector: (row) => (
        <div>
          <ReactPlayer
            src={row?.url}
            controls={false} 
            style={{
              width: "10px",
              height: "10px",
              "--controls": "none",
            }}
          />
        </div>
      ),
      sortable: true,
      wrap: true,
    },
     {
      name: "Order",
      width: "120px",
      selector: (row) => row?.order,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,

      width: "120px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
        </div>
      ),
    },
  ]);
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  useEffect(() => {
    getCategory();
    getVideoArticleList();
  }, []);
  const getVideoArticleList = () => {
      setValue("loading",true)
    listVideoArticleAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) { 
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("loading", false);
        } else if (res.data.status === false) {
          setValue("loading", false);
          setValue("data", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("loading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getCategory = () => {
    categoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) { 
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") { 
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const resetF = () => {
    setValue("title", null);
    setValue("description", null);
    setValue("category", "");
    setValue("status", null);
    setValue("image", null);
    setValue("img", null);
    setValue("order", "");
    setValue("url", "");
    setMode("Add");
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("category", row?.category);
    setValue("title", row?.title);
    setValue("url", row?.url);
    setValue("order", row?.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
    setValue("description", row?.description);
    setValue("img", BASE_URL_IMG + row?.image);
    setValue("image", BASE_URL_IMG + row?.image);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("title", watch("title"));
    formData.append("url", watch("url"));
    formData.append("order", watch("order"));
    formData.append("status", watch("status")?.value);
    formData.append("description", watch("description"));
    formData.append("category_id", watch("category")?.value);
    const image = watch("img");
    if (image instanceof File) {
      formData.append("image", image);
    } else if (typeof image === "string") {
      formData.append("image", image);
    }
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      addVideoArticleAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getVideoArticleList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
     if (mode == "Edit") {
      updateVideoArticleAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getVideoArticleList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
 const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateVideoArticleAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getVideoArticleList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
      const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  return (
    <>
      <Head title={"Video Articles"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Video Articles"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Article Title"}
                      name={"title"}
                      placeholder={"Enter article name"}
                      required
                      min={2}
                      max={150}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                    />
                  </Col>
                  <Col md="2">
                    <ImageUpload
                      id="image"
                      watch={watch}
                      label={"Upload Article Image"}
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image={"img"}
                      image_url={"image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Order"}
                      name={"order"}
                      placeholder={"Enter category order"}
                      required
                      min={1}
                      max={2}
                      inputPattern={/[^0-9]/g}
                      pattern={/^[1-9][0-9]{0,2}$/}
                      patternMsg={"Enter a Order greater than 0 and up to 99"}
                    />
                  </Col>
                  <Col md={`2`}>
                    <Status register={register} watch={watch} setValue={setValue} trigger={trigger} errors={errors} />
                  </Col>
                  <Col md="12" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Article URL"}
                      name={"url"}
                      placeholder={"Enter article url"}
                      required
                      min={25}
                    />
                  </Col>
                  <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Description"}
                      name={"description"}
                      placeholder={"Enter short disease description"}
                      required
                      min={25}
                      max={1000}
                      cols={2}
                      row={2}
                    />
                  </Col>
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          )}
          <MyDataTable data={data || []} columns={column} title={"Video Article List"} isLoading={loading} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
        <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
  
    </>
  );
};

export default VideoArticle;
